import { asyncActionCreators } from '../../utils/actions';

export const loadGeozones = asyncActionCreators('Geozones/LOAD');
export const createGeozone = asyncActionCreators('Geozones/CREATE');
export const deleteGeozone = asyncActionCreators('Geozones/DELETE');
export const activateGeozone = asyncActionCreators('Geozones/ACTIVATE');
export const updateGeozone = asyncActionCreators('Geozones/UPDATE');
export const updateGeozoneFinished = asyncActionCreators('Geozones/UPDATE_FINISHED');



// WEBPACK FOOTER //
// ./src/sagas/geozones/actions.js